module.exports = __webpack_public_path__ + "static/hcpettreats-b7f502f34ef03a9e3704582be73c9cc7.jpg";